import React from 'react';
import { Alert, Breadcrumb, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { routes, WEBHOOK_UPDATE_MESSAGE } from '../../../common/constants';
import './everbridge.scss';
import MapEverbridgeGroupModal from '../../../components/mapEverbridgeGroupModal/index';
import { useEverbridge } from './useEverbridge';
import ConfigureEverbridgeTokenModal from '../../../components/configureEverbridgeTokenModal';
import CopyInputField from '../singlewire/copyInputField';

const Everbridge = () => {
    const { text, copied, setCopied, webhookUrlUpdateRequired } = useEverbridge();
    return (
        <div className='integration-container'>
            <div className='everbridge-body'>
                <div className='integration-header'>
                    <div className='integration-header-content'>
                        <div className='integration-heading'>3rd Party Integration</div>
                    </div>
                    <Col>
                        <div className='integration-breadcrumb'>
                            <Breadcrumb>
                                <Breadcrumb.Item
                                    linkAs={Link}
                                    linkProps={{ to: `${routes.integrations}` }}
                                >
                                    3rd Party Integration
                                </Breadcrumb.Item>
                                <Breadcrumb.Item active>
                                    Everbridge Configuration
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                    </Col>
                    <Col sm={8}></Col>
                </div>
                {webhookUrlUpdateRequired && (
                    <Alert variant='warning' className='webhook-update-alert'>
                        {WEBHOOK_UPDATE_MESSAGE}
                    </Alert>
                )}
                <div>
                    <Row>
                        <Col sm={1} className='label'>
                            <h5>Step: 1</h5>
                        </Col>
                        <Col sm={3}>
                            <ConfigureEverbridgeTokenModal />
                        </Col>
                        <Col sm={2} className='label'>
                            <h5>Webhook URL:</h5>
                        </Col>
                        <Col sm={5}>
                            <CopyInputField
                                text={text}
                                copied={copied}
                                setCopied={setCopied}
                            />
                        </Col>
                    </Row>
                    <Row className='mapsite-btn'>
                        <Col sm={1} className='label'>
                            <h5>Step: 2</h5>
                        </Col>
                        <Col sm={2}>
                            <MapEverbridgeGroupModal />
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default Everbridge;
